import React, { Component } from 'react';
import { sharedConstants } from 'shared-helpers';

// constants
import { CONTACT_FORM_TYPE, HUBSPOT_FORM_SOURCE, TAXONOMIES } from '../utilities/constants';

// helpers
import { isValidEmail } from '/src/utilities/helpers';
import AmplitudeHelperClass from '../utilities/amplitudeHelper';

// apis
import taxonomyApi from '/src/apis/taxonomyApi';
import contactSalesApi from '../apis/contactSalesApi';

const amplitudeHelper = new AmplitudeHelperClass();

class ContactSalesForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            // form fields
            first_name: '',
            last_name: '',
            email: '',
            position: '',
            company_name: '',
            companyType: '',
            reason: '',

            // options
            reasons: [],
            companyTypes: [],
            formType: '',
            formTitle: '',
            formAction: '',
            taxonomyType: '',
            page: '',

            error: '',
            isFieldEmpty: false,
            success: false,
            isSubmitting: false,
        };
    }

    componentDidMount() {
        let formType = '';
        let formTitle = '';
        let formAction = '';
        let taxonomyType = '';

        if (this.props.formType === "enterprise") {
            formType = CONTACT_FORM_TYPE.enterprise;
            formTitle = 'Want the underlying data for this research?';
            formAction = 'Contact Sales';
            taxonomyType = TAXONOMIES.salesContactOptions;
        } else if (this.props.formType === "marketing") {
            formType = CONTACT_FORM_TYPE.marketing;
            formTitle = 'Advertise With Us';
            formAction = 'Contact Us';
            taxonomyType = TAXONOMIES.marketingContactOptions;
        } else if (this.props.formType === "demo") {
            formType = CONTACT_FORM_TYPE.demo_request;
            formTitle = 'Get a personalized tour';
            formAction = 'Request a demo';
            taxonomyType = TAXONOMIES.demoContactOptions;
        } else {
            formType = CONTACT_FORM_TYPE.enterprise;
            formTitle = 'Want the underlying data for this research?';
            formAction = 'Contact Sales';
            taxonomyType = TAXONOMIES.salesContactOptions;
        }

        this.setState({
            formType,
            formTitle,
            formAction,
            taxonomyType,
            page: this.props.pageType
        }, () => {
            this.getReasons();
            this.getCompanyTypes();
        });

    }

    getReasons = () => {
        taxonomyApi.getTaxonomyType(this.state.taxonomyType).then(
            response => {
                const reasons = response.map(reason => {
                    return { value: reason.id, label: reason.name };
                });

                this.setState({ reasons });
            }
        )
    }

    getCompanyTypes = () => {
        taxonomyApi.getTaxonomyType(TAXONOMIES.companyType).then(
            response => {
                const companyTypes = response.map(type => {
                    return { value: type.id, label: type.name };
                });
                this.setState({ companyTypes });
            }
        )
    }

    amplitudeTrackEvent = () => {
        let page = "";

        if (this.props.pageType) {
            page = this.props.pageType;
        } else {
            page = "Content App";
        }

        const event = `Form submitted from ${page} page`;

        amplitudeHelper.trackEvent(event);
    }

    handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;

        this.setState({
            [name]: value
        });
    }

    handleSubmit = async () => {
        if (this.state.isSubmitting) {
            return;
        }

        this.setState({ isSubmitting: true });

        if (!this.handleValidate()) {
            return;
        }

        const { first_name, last_name, email, position, company_name, reason, companyType, formType, page } = this.state;
        const hubspotSource = page === 'news' ? HUBSPOT_FORM_SOURCE.marketing_widgets : HUBSPOT_FORM_SOURCE.research_widgets;
        let utmSource, utmMedium, utmCampaign;

        if (window.location.search) {
            const params = new URLSearchParams(window.location.search);

            utmSource = params.get('utm_source');
            utmMedium = params.get('utm_medium');
            utmCampaign = params.get('utm_campaign');
        }

        const payload = {
            first_name,
            last_name,
            email,
            position,
            company_name,
            company_type_id: companyType,
            reason_id: reason,
            type: formType,
            page: hubspotSource,
            path: window.location.pathname,
            utm_source: utmSource,
            utm_medium: utmMedium,
            utm_campaign: utmCampaign
        };

        contactSalesApi.post(payload).then(
            response => {
                this.setState({
                    first_name: '',
                    last_name: '',
                    email: '',
                    position: '',
                    company_name: '',
                    companyType: '',
                    reason: '',
                    isFieldEmpty: false,
                    isSubmitting: false,
                    success: true,
                    error: '',
                });

                this.amplitudeTrackEvent();
            }
        ).catch(error => {
            this.setState({
                error: 'There was an error submitting the form, please reload the page and try again.',
                isSubmitting: false
            });
        });
    }

    handleValidate = () => {
        const { first_name, last_name, email, position, company_name, companyType, reason } = this.state;

        const missingFields = (first_name === '' || last_name === '' || email === '' || position === '' || company_name === '' || companyType === '' || reason === '');
        const invalidEmail = !isValidEmail(email);

        if (missingFields) {
            this.setState({
                error: "Please fill in all the required fields.",
                success: false,
                isFieldEmpty: true,
                isSubmitting: false
            });

            return false;
        } else if (invalidEmail) {
            this.setState({
                error: "Please enter a valid email address.",
                success: false,
                isSubmitting: false
            });

            return false;
        } else {
            this.setState({
                error: '',
                success: false,
                isFieldEmpty: false
            });

            return true;
        }
    }

    render() {
        const { first_name, last_name, email, position, company_name, reason, reasons, companyType, companyTypes, isFieldEmpty } = this.state;

        return (
            <div className="content-body-widget-main">
                <div className="contact-sales-widget">

                    <div className="db-box widget-box">

                        <div class="db-header">
                            <div>{this.state.formTitle}</div>
                        </div>

                        <div className="widget-form">
                            <input
                                className={isFieldEmpty && !email ? "error" : ""}
                                name='email'
                                type="text"
                                placeholder='Email'
                                value={email}
                                onChange={this.handleChange}
                            />

                            <div className="row">
                                <div className="col-12 col-md-6 col-lg-6 col-xl-12">
                                    <input
                                        className={isFieldEmpty && !first_name ? "error" : ""}
                                        name='first_name'
                                        type="text"
                                        placeholder='First Name'
                                        value={first_name}
                                        onChange={this.handleChange}
                                    />
                                </div>
                                <div className="col-12 col-md-6 col-lg-6 col-xl-12">
                                    <input
                                        className={isFieldEmpty && !last_name ? "error" : ""}
                                        name='last_name'
                                        type="text"
                                        placeholder='Last Name'
                                        value={last_name}
                                        onChange={this.handleChange}
                                    />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-12 col-md-6 col-lg-6 col-xl-12">
                                    <input
                                        className={isFieldEmpty && !company_name ? "error" : ""}
                                        name='company_name'
                                        type="text"
                                        placeholder='Company Name'
                                        value={company_name}
                                        onChange={this.handleChange}
                                    />
                                </div>
                                <div className="col-12 col-md-6 col-lg-6 col-xl-12">
                                    <select
                                        name='companyType'
                                        value={companyType}
                                        data-testid="contact-sales-form-reason"
                                        onChange={this.handleChange}
                                        className={isFieldEmpty && !companyType ? "error" : ""}
                                        aria-label="Select your company type"
                                        dir="ltr">
                                        <option value='' disabled selected hidden>Company Type</option>
                                        {companyTypes.map(companyType => <option key={companyType.value} value={companyType.value}>{companyType.label}</option>)}
                                    </select>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-12 col-md-6 col-lg-6 col-xl-12">
                                    <input
                                        className={isFieldEmpty && !position ? "error" : ""}
                                        name='position'
                                        type="text"
                                        placeholder='Position'
                                        value={position}
                                        onChange={this.handleChange}
                                    />
                                </div>
                                <div className="col-12 col-md-6 col-lg-6 col-xl-12">
                                    <select
                                        name='reason'
                                        className={`mb-2 ${isFieldEmpty && !reason ? "error" : ""}`}
                                        value={reason}
                                        onChange={this.handleChange}
                                        aria-label="Select your reason for contacting us"
                                        dir="ltr">
                                        <option value='' disabled selected hidden>What are you looking for?</option>
                                        {reasons.map(reason => <option key={reason.value} value={reason.value}>{reason.label}</option>)}
                                    </select>
                                </div>
                            </div>

                        </div>

                        <div className="feedback-section">
                            <div className="message mt-0">
                                {this.state.error &&
                                    <div className="red mt-0">
                                        {this.state.error}
                                    </div>
                                }
                                {this.state.success &&
                                    <div className="red mt-0">
                                        Thank you for contacting us, we will get back to you shortly
                                    </div>
                                }
                            </div>
                            <div className="mt-0">
                                <div className="btn btn-main btn-block" onClick={this.handleSubmit}>
                                    {this.state.isSubmitting ?
                                        <>
                                            <i className="fas fa-circle-notch fa-spin mr-2"></i>
                                            Submitting
                                        </>
                                        : this.state.formAction
                                    }
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        )
    }

}

export default ContactSalesForm;
